import React from "react";
import SuccessStoriesSvg from "../assets/svg/SuccessStories.svg"; // Assuming your image path
import Banner from "./Home/Banner/banner";
import CaseStudies from "./SuccessStories/CaseStudies";

const SuccessStoriesImage = () => {
  return (
    <>
      <div className="lg:mb-12 max-md:mb-16">
        <Banner />;
      </div>
      <div className="mb-32">
        <CaseStudies />
      </div>
    </>
  );
};

export default SuccessStoriesImage;
